import { NoteSimple } from './note'
import { Owner } from './user'

export class SimpleQuiz {
  id: number
  owner: Owner
  quiz_title: string
  quiz_description: string
  note_titles: string[]
  easy_questions_count: number
  intermediate_questions_count: number
  hard_questions_count: number
  likes: number
  is_liked: boolean
  bookmarks: number
  is_bookmarked: boolean
  is_mine: boolean
  time_since_creation: string
  created_at: string
  last_update: string
  title: string
  description: string
  result: number | null
  questions_count: number
  completed_time: string | null
  deadline: number
  notes: number[]
  privacy: string
}

export interface Answer {
  id: number
  text: string
  is_correct: boolean
}

export interface Question {
  id: number
  text: string
  question_type: string
  level: string
  answers: Answer[]
}

export interface WrongAnswer {
  question: Question
  selected_answer: Answer
  correct_answer: Answer | null
}

export interface QuizResult {
  score: number
  correct_count: number
  total_questions: number
  time_taken: number | string
  wrong_answered_questions: WrongAnswer[]
}

export class Quiz {
  id: number
  owner: Owner
  title: string
  description: string
  questions: Question[]
  questions_count: number
  notes: NoteSimple[]
  notes_count: number
  result: number | null
  completed_time: string | null
  deadline: number
  created_at: string
  last_update: string
  time_since_creation: string
  likes: number
  is_liked: boolean
  bookmarks: number
  is_bookmarked: boolean
  is_mine: boolean
  privacy: string
}
